/* eslint-disable */
import React from "react";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";
import { Link as MUILink } from "@material-ui/core";
import { LinkProps } from "@material-ui/core/Link";
import cn from "classnames";
import * as H from "history";
import { useLinkStyles } from "./styles";

const LinkComponent = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
  <RouterLink innerRef={ref} {...props} />
));

export function Link({
  active,
  isHeaderLink,
  ...otherProps
}: LinkProps & RouterLinkProps & { disabled?: boolean; active?: boolean; isHeaderLink?: boolean }) {
  const to = otherProps.to || (otherProps.href as H.LocationDescriptor<H.LocationState>);
  const isOuterLink = `${to}`.includes("http");
  const target = isOuterLink ? "_blank" : "_self";
  const classes = useLinkStyles(otherProps);
  const { disabled } = otherProps;
  const classname = cn(classes.common, otherProps.className, {
    [classes.disabled]: disabled,
    [classes.active]: !isHeaderLink && !!active,
  });

  const onClick = (event: React.MouseEvent) => {
    if (disabled) {
      event.preventDefault();
    }

    if (isOuterLink) {
      event.preventDefault();
      window.open(`${to}`, target);
    }

    if (otherProps.onClick) {
      otherProps.onClick(event as React.MouseEvent<HTMLAnchorElement, MouseEvent>);
    }
  };

  return (
    <MUILink
      component={LinkComponent}
      target={target}
      {...(otherProps as LinkProps)}
      to={to}
      onClick={onClick}
    />
  );
}

export default Link;
